import { useEffect, useState } from 'react';
import { Card, Box, Typography, Grid, Divider, Container } from '@mui/material';
import SupplierSelectComponent from '../../supplier-select-component/SupplierSelectComponent';
import SupplierSummary from './supplier-summary';
import "../acknowledgment-component/summary-acknowledgment.css";
import { useOktaAuth } from '@okta/okta-react';
import { useNotificationAPI } from '../../as2-onboarding-component/hooks/useClient';

const SummaryAcknowledgment = (props) => {
    const { oktaAuth } = useOktaAuth();
    const notificationApi = useNotificationAPI(oktaAuth.getAccessToken());

    const [initiatives, setInitiatives] = useState([]);
    const { handleKeyDown, usertype } = props;
    const [onSelect, setOnSelect] = useState([]);
    const [initialRows, setInitialRows] = useState([]);
    const [pending, setPending] = useState(0);
    const [complete, setComplete] = useState(0);
    const [rows, setRows] = useState([]);

    const fetchGeneralData = async () => {
        try{
            const response = await notificationApi.get('/notifications');
            const data = response.data;
            const notifications = []
            const initiativesList = new Set();

            data.map(async (element) => {
                //notifications.push(createData(element.notification.title, element.notification.supplier, element.notification.notification_read ? 'Complete' : 'Pending', element.notification.creation_date.substring(0, 10)))
                initiativesList.add(element.notification.title)

                for (const supplier of element.suppliers) {
                    const supplierNumber = await getSupplierNumber(supplier.supplier_id);
                    notifications.push({initiative: element.notification.title, supplier: supplierNumber, status: supplier.notification_read ? 'Complete' : 'Pending', doneDate: supplier.confirmation_date ? supplier.confirmation_date:'N/A'})
                }
            })
            setRows(notifications);
            setInitiatives(Array.from(initiativesList));
        }
        catch (error) {
            console.error('Error fetching notifications:', error);
        }

    }

    const getSupplierNumber = async (suppllier_id) => {
        const response = await notificationApi.get(`/suppliers/supplier/${suppllier_id}`);
        const data = response.data;
        return data.supplier_number;
    }

    useEffect(() => {
        fetchGeneralData();
    }, []);

    useEffect(() => {
        const firstRows = rows.slice(0, 3)

        const pendingCount = firstRows.reduce((acc, row) => acc + (row.status.trim() === 'Pending' ? 1 : 0), 0);
        const completeCount = firstRows.reduce((acc, row) => acc + (row.status.trim() === 'Complete' ? 1 : 0), 0);

        setInitialRows(firstRows)
        setPending(pendingCount);
        setComplete(completeCount);
    }, [rows])


    const InitiativeChangeHandler = (event) => {
        console.log(event.value)
        const seenSuppliers = new Set();

        const filteredRows = rows.filter((row) => {
            if (row.initiative === event) {
                if (seenSuppliers.has(row.supplier)) {
                    return false;
                } else {
                    seenSuppliers.add(row.supplier);
                    return true;
                }
            }
            return false;
        });


        const pendingCount = filteredRows.reduce((acc, row) => acc + (row.status.trim() === 'Pending' ? 1 : 0), 0);
        const completeCount = filteredRows.reduce((acc, row) => acc + (row.status.trim() === 'Complete' ? 1 : 0), 0);

        setOnSelect(filteredRows);
        setPending(pendingCount);
        setComplete(completeCount);

    };

    return (
        <Container maxWidth={true} sx={{ width: '100%', maxWidth: '100% !important', padding: 0, flexDirection: 'column !important' }} >
            <Box p={2} sx={{ width: '100%', maxWidth: '100% !important', padding: 0, flexDirection: 'column !important' }}>
                <Card className="paddingcontainer" style={{ width: "100%" }} >
                    <div p={10}>
                        <Typography gutterBottom variant="h2" component="h2" p={3}>Summary</Typography>
                        <Divider className='divider-summary' />
                        <Grid item p={5} >
                            <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                                Initiative name
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className="column">
                                        <div className=" col selectAlignment">
                                            <SupplierSelectComponent
                                                userType={usertype}
                                                supplierList={initiatives.map(item => ({ label: item, value: item.toLowerCase().replace(/\s+/g, '-') }))}
                                                supplierChangeHandler={InitiativeChangeHandler}
                                                handleKeyDown={handleKeyDown}
                                            />

                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <SupplierSummary selectedRows={onSelect} initialRows={initialRows} pending={pending} complete={complete} />
                        </Grid>
                    </div>
                </Card>
            </Box>
        </Container>
    )
}
export default SummaryAcknowledgment;
